import { SEASONAL_PDP_BANNER_CONSTANTS } from '../CalendarProductPage/seasonalConstants'

export const SEASONAL_PRODUCT_STATES = {
  ...SEASONAL_PDP_BANNER_CONSTANTS,

  // Each Frame pricing structure will mimic the shape in contentful to facilitate overriding prices in FrameProductForm component
  prices: {
    frame10: {
      en_original_price: '159.99',
      en_discounted_price: '119.99',
      en_discount_bubble: '$40 OFF',
      en_original_price_Silver: '159.99',
      en_discounted_price_Silver: '119.99',
      en_discount_bubble_Silver: '$40 OFF',
      en_original_price_White: '159.99',
      en_discounted_price_White: '119.99',
      en_discount_bubble_White: '$40 OFF',
      en_original_price_Gold: '159.99',
      en_discounted_price_Gold: '119.99',
      en_discount_bubble_Gold: '$40 OFF',
      en_ca_original_price: '199',
      en_ca_discounted_price: '169',
      en_ca_discount_bubble: '$30 OFF',
      en_au_original_price: '249',
      en_au_discounted_price: '169',
      en_au_discount_bubble: '$100 OFF',
      en_gb_original_price: '159',
      en_gb_discounted_price: '109',
      en_gb_discount_bubble: '£50 OFF',
    },
    frame15: {
      en_original_price: '299.99',
      en_discounted_price: '219.99',
      en_discount_bubble: '$80 OFF',
      en_ca_original_price: '349',
      en_ca_discounted_price: '289',
      en_ca_discount_bubble: '$60 OFF',
      en_au_original_price: 'NONE',
      en_au_discounted_price: 'NONE',
      en_au_discount_bubble: 'NONE',
      en_gb_original_price: '249',
      en_gb_discounted_price: '199',
      en_gb_discount_bubble: '£50 OFF',
    },
    frame10F2: {
      Wood: {
        prices: {
          originalPrice: '199.99',
          discountedPrice: '169.99',
          discountBubble: '$30 OFF',
        },
      },
      Classic: {
        prices: {
          originalPrice: '169.99',
          discountedPrice: '139.99',
          discountBubble: '$30 OFF',
        },
      },
      'Shadow Box': {
        prices: {
          originalPrice: '199.99',
          discountedPrice: '169.99',
          discountBubble: '$30 OFF',
        },
      },
      Cover: {
        prices: {
          originalPrice: '169.99',
          discountedPrice: '139.99',
          discountBubble: '$30 OFF',
        },
      },
    },
    calendar15F2: {
      Classic: {
        prices: {
          originalPrice: '299.99',
          discountedPrice: '259.99',
          discountBubble: '$40 OFF',
        },
      },
      'Shadow Box': {
        prices: {
          originalPrice: '319.99',
          discountedPrice: '279.99',
          discountBubble: '$40 OFF',
        },
      },
    },
  },
}
